module.exports = __webpack_public_path__ + "img/MCO.42e1fc49.svg";